<template>
  <section class="hero">
    <div class="hero-background">
      <div class="grid-bg"></div>
      <div class="accent-line accent-top"></div>
      <div class="accent-line accent-right"></div>
    </div>
    
    <div class="hero-content">
      <div class="container">
        <div class="hero-header">
          <h1 class="hero-title">{{ $t('enterprise.heroTitle') }}</h1>
          <p class="hero-subtitle">{{ $t('enterprise.heroSubtitle') }}</p>
        </div>

        <div class="metrics-section">
          <div class="metric-row">
            <div class="metric-item">
              <div class="metric-label">{{ $t('enterprise.accurateMatching') }}</div>
              <div class="metric-check">✓</div>
            </div>
            <div class="metric-divider"></div>
            <div class="metric-item">
              <div class="metric-label">{{ $t('enterprise.riskControl') }}</div>
              <div class="metric-check">✓</div>
            </div>
            <div class="metric-divider"></div>
            <div class="metric-item">
              <div class="metric-label">{{ $t('enterprise.flexibleCollaboration') }}</div>
              <div class="metric-check">✓</div>
            </div>
          </div>
        </div>

        <div class="hero-actions">
          <button class="action-button primary" @click="handleContactSales">
            {{ $t('enterprise.contactSales') }}
          </button>
          <button class="action-button secondary" @click="handleViewDemo">
            {{ $t('enterprise.viewDemo') }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSectionEnterprise',
  methods: {
    handleContactSales() {
      alert('企业商务合作咨询 - 将显示联系表单')
    },
    handleViewDemo() {
      window.open('https://skillith.cn/', '_blank')
    }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 80vh;
  padding-top: 140px;
  padding-bottom: 60px;
  background: #020B1A;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.grid-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  opacity: 0.5;
}

.accent-line {
  position: absolute;
  background: linear-gradient(90deg, rgba(0, 185, 255, 0.1), transparent);
  opacity: 0.3;
}

.accent-top {
  top: 15%;
  left: 0;
  right: 0;
  height: 1px;
}

.accent-right {
  top: 0;
  right: 15%;
  width: 1px;
  bottom: 0;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 2rem;
}

.hero-header {
  margin-bottom: 3rem;
}

.hero-title {
  font-size: 3rem;
  font-weight: 800;
  color: #F9FAFB;
  line-height: 1.2;
  margin: 0 0 1rem 0;
  letter-spacing: -0.02em;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: rgba(209, 213, 219, 0.85);
  line-height: 1.7;
  margin: 0;
  max-width: 600px;
}

.metrics-section {
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.metric-row {
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
}

.metric-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  min-width: 250px;
}

.metric-label {
  font-size: 0.95rem;
  color: rgba(209, 213, 219, 0.8);
  line-height: 1.5;
}

.metric-check {
  font-size: 1.2rem;
  color: #00B9FF;
  font-weight: 700;
  flex-shrink: 0;
}

.metric-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  display: none;
}

.hero-actions {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.action-button {
  padding: 14px 32px;
  font-size: 0.95rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.action-button.primary {
  background: linear-gradient(135deg, #00B9FF, #00E5CC);
  color: #020B1A;
}

.action-button.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(0, 185, 255, 0.25);
}

.action-button.secondary {
  background: transparent;
  color: #F9FAFB;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
}

.action-button.secondary:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.05);
  transform: translateY(-2px);
}

@media (max-width: 1024px) {
  .hero-title {
    font-size: 2.2rem;
  }

  .metric-divider {
    display: none !important;
  }

  .metric-row {
    flex-direction: column;
    gap: 1.5rem;
  }

  .metric-item {
    min-width: auto;
  }
}

@media (max-width: 768px) {
  .hero {
    padding-bottom: 40px;
  }

  .hero-title {
    font-size: 1.8rem;
  }

  .hero-subtitle {
    font-size: 0.95rem;
  }

  .hero-actions {
    flex-direction: column;
  }

  .action-button {
    width: 100%;
    text-align: center;
  }

  .container {
    padding: 0 1rem;
  }
}
</style>
